import React, { useState } from "react";
import { FormattedMessage } from "react-intl";
import { Link } from "react-router-dom";
import { TABLE_MAP } from "../../config/constants";

export default function Navbar({ path }) {
  const [active, setActive] = useState(false);

  return (
    <React.Fragment>
      <header id="header" className="">
        {/* scrolled */}
        <div className="header-nav">
          <div className="bs-container">
            <div className="nav-content clearfix">
              <div className="logo">
                <Link to="/">
                  <img
                    // src="/images/logo.gif"
                    src="/images/logo-header.png"
                    alt=""
                    data-aos="fade-down"
                    data-aos-delay="300"
                  />
                </Link>
              </div>
              <div className="nav">
                <span className="show__menu" onClick={() => setActive(!active)}>
                  <i className="fas fa-bars" />
                </span>
                <div className={`menu ${active ? "active" : ""}`}>
                  <span
                    className="close__menu"
                    onClick={() => setActive(false)}
                  >
                    <i className="far fa-window-close" />
                  </span>
                  <ul className="menu-list clearfix">
                    <li className="menu-list__item">
                      <Link
                        to="/"
                        className={`menu-list__link ${
                          path === "/" ? "active" : ""
                        }`}
                      >
                        <FormattedMessage id="nav.home" />
                      </Link>
                    </li>
                    <li className="menu-list__item">
                      <Link
                        to="/gioi-thieu"
                        className={`menu-list__link ${
                          path === "/gioi-thieu" ? "active" : ""
                        }`}
                      >
                        <FormattedMessage id="nav.intro" />
                      </Link>
                    </li>

                    <li className="menu-list__item">
                      <span
                        className={`menu-list__link ${
                          path === "/bang-xep-hang" ? "active" : ""
                        }`}
                      >
                        <FormattedMessage id="nav.rank" />
                      </span>

                      <ul
                        className="dropdown-list"
                        style={{ background: "#fff" }}
                      >
                        <li className="dropdown-list__item">
                          {Array(19)
                            .fill("")
                            .map((item, ind) => {
                              const table = ind + 1;
                              return (
                                <div key={table} className="popup-item">
                                  <Link
                                    to={`/bang-xep-hang/${table}`}
                                    className="dropdown-list__link"
                                    style={{
                                      color: "#2B2438",
                                    }}
                                  >
                                    {TABLE_MAP[table]}
                                  </Link>
                                </div>
                              );
                            })}
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
}
